import React from 'react';
import Button from '../../components/subcomponents/controls/button'
import SubformDetails from '../../components/subcomponents/subform_details'
import FormHeader from '../../components/subcomponents/formheader'
import LogLogin from './log_login'
import LogControllers from './log_controllers'

class LogsList extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            logs_type: ''
        }
    }
    selectLoginLog() {
        this.setState({logs_type: 'login'})
    }
    selectControllerLog() {
        this.setState({logs_type: 'controller'})
    }
    showDetails() {
        if (this.state.logs_type === 'login') {
            return (<LogLogin/>)
        }
        if (this.state.logs_type === 'controller') {
            return (<LogControllers/>)
        }
    }
    render() {
        return (
            <div className="form_wrap log_list">
                <FormHeader title='LOGS'/>
                <div className="toolbar">
                    <Button name="log_login" label="Login log" onClick={this.selectLoginLog.bind(this)}/>
                    <Button name="log_controller" label="Controller log" onClick={this.selectControllerLog.bind(this)}/>
                </div>
                <SubformDetails className="master width_50">

                </SubformDetails>
                {this.showDetails()}
            </div>
        )
    }
}

export default LogsList;